import {useFeatureFlagEnabled} from '~/lib/analytics';

// Targeted by PostHog organization group, so one release condition covers a
// firm's advisors (main app) and their clients (this app).
export const PAGE_AGGREGATION_FLAG = 'page-aggregation';

export const usePagesHeaderEnabled = () =>
  !!useFeatureFlagEnabled(PAGE_AGGREGATION_FLAG);
